









import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Building } from '@/modules/backend/Entities/Building';
import DeleteConfirmation from '@/layouts/DeleteConfirmation.vue';
import Mixin from '@/mixins/base';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import { resolveModule } from '@/store';

@Component({
  mixins: [Mixin],
  components: {
    'delete-confirmation': DeleteConfirmation
  }
})
export default class BuildingDeleteButton extends Mixins(Mixin) {
  private readonly buildingsModule: BuildingsModule = resolveModule(BuildingsModule);

  @Prop({ required: true }) private building!: Building;

  private async performBuildingDelete(): Promise<void> {
    await this.buildingsModule.Remove(this.building.getId());
  }
}
